import { render, staticRenderFns } from "./PropertyRateStatement.vue?vue&type=template&id=e7cc1d9a"
import script from "./PropertyRateStatement.vue?vue&type=script&setup=true&lang=js"
export * from "./PropertyRateStatement.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports